// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__vU65b","betaContainer":"Footer_betaContainer__xEO7h","uppercase":"Footer_uppercase__vITIn","bold":"Footer_bold___echK","beta":"Footer_beta__A0mLa"};